<template>
  <div class="header-wrap">
    <!-- 头部左侧 -->
    <!-- 团队与客户 -->
    <div v-if="$route.meta.type === 'teamCustomer'" class="left">
      <span
        :style="{
          fontWeight: customType === 'getMemberList' ? 'bold' : 'normal',
        }"
        @click="getCustomList('getMemberList')"
        >团队</span
      >
      <span> | </span>
      <span
        :style="{
          fontWeight: customType === 'getCustomerList' ? 'bold' : 'normal',
        }"
        @click="getCustomList('getCustomerList')"
        >客户</span
      >
    </div>

    <!-- 团队管理 -->
    <div v-else-if="$route.meta.type === 'teamManage'" class="left">
      <span
        :style="{
          fontWeight: customType === 'getMemberList' ? 'bold' : 'normal',
        }"
        @click="getCustomList('getMemberList', 'S')"
      >
        团队管理
      </span>
      <span> | </span>
      <span class="yellow-text" @click="openDrawer('岗位设置')">岗位设置</span>
      &nbsp;
      <span class="yellow-text" @click="getCustomList('getMemberList', 'U')"
        >成员审批（{{ userInfo.pendMemberNum }}人）</span
      >
    </div>

    <!-- 付费 -->
    <div v-else-if="$route.meta.type === 'spacePay'" class="left">
      <span
        :style="{
          fontWeight: customType === 'getMemberList' ? 'bold' : 'normal',
        }"
        @click="getCustomList('getMemberList', 'S')"
      >
        {{ userInfo.spaceName }}
      </span>
      <span>&nbsp;</span>
      <span class="init-text">{{ getUserType(userInfo.userType) }}</span>
    </div>

    <!-- 其他 -->
    <div v-else class="left">
      <span>{{ headerTitle }}</span>
    </div>

    <!-- 头部右侧 -->
    <div class="right">
      <!-- 档务搜索框-->
      <el-input
        v-if="btnName === '上传资源'"
        v-model="searchValue"
        placeholder="档务搜索"
        @keyup.enter.native="searchFile"
      >
        <i slot="suffix" class="el-icon-search" @click="searchFile"></i>
      </el-input>
      <!-- 操作按钮 -->
      <el-button v-if="btnName" round @click="openDrawer(btnName)">
        {{ btnName }}
      </el-button>
      <!-- 创建档夹 按钮 -->
      <el-button
        v-if="btnName === '上传资源'"
        round
        style="background: #ce9f02"
        @click="openDrawer('创建档夹')"
      >
        创建档夹
      </el-button>
      <!-- 续费有效期 -->
      <div v-if="$route.meta.type === 'spacePay'" class="renewal-div">
        <p
          v-if="userInfo.productExpTime"
          :style="{ color: remainDays <= 0 ? '#f06666' : '#1b55f4' }"
          style="color: #1b55f4; margin-right: 20px"
        >
          有效期至：{{ userInfo.productExpTime }}
        </p>
        <p
          v-if="userInfo.productExpTime"
          :style="{ color: remainDays <= 0 ? '#f06666' : '#1b55f4' }"
          style="color: #1b55f4; margin-right: 30px"
        >
          {{
            remainDays <= 0
              ? `已过期${Math.abs(remainDays) + 1}天，请续费！`
              : `剩余${remainDays}天`
          }}
        </p>
        <p @click="spacePay(1)">
          {{ userInfo.productExpTime ? "续费" : "开通" }}
        </p>
        <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
        <p @click="spacePay(2)">订单记录</p>
      </div>
      <!-- 头像 -->
      <div class="avator" @click="loginout">
        <img
          :src="userInfo.headerUrl"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>
    </div>

    <!-- 右侧弹窗 -->
    <wan-drawer ref="wanDrawer" :drawer-params="drawerParams"></wan-drawer>
    <!-- 右侧弹窗 -->
    <wan-drawer
      ref="createFolderDrawer"
      :drawer-params="createFolderDrawerParams"
    >
      <wan-create-folder
        ref="create-folder"
        slot="content"
        :drawer-params="createFolderDrawerParams"
      ></wan-create-folder>
      <div slot="footer" class="wan-drawer-footer" style="display: block">
        <div class="wan-drawer-back" style="float: right" @click="onsubmit">
          提交
        </div>
      </div>
    </wan-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import wanDrawer from "@/components/wan-drawer";
import wanCreateFolder from "@/components/wan-create-folder";

export default {
  name: "wan-header",

  components: {
    wanDrawer,
    wanCreateFolder,
  },

  computed: {
    ...mapState(["headerTitle", "userInfo", "searchFileValue"]),

    btnName() {
      console.log(this.$route);
      return this.$route.meta.btnName;
    },
  },

  data() {
    return {
      searchValue: "",
      customType: "getMemberList",
      // 给弹窗的参数
      drawerParams: {
        title: "上传资源",
        drawerType: 1,
      },
      // 给弹窗的参数
      createFolderDrawerParams: {
        title: "创建/修改档夹",
        drawerType: 1,
        isDrawerContentSlot: true,
        isDrawerFooterSlot: true,
        operation: true,
      },
      remainDays: 0,
    };
  },

  watch: {
    $route: {
      handler() {
        // customerInfo 是客户信息  getCustomerList 查客户  getMemberList 查团队 也就是成员
        this.customType =
          this.$route.meta.type === "customerInfo"
            ? "getCustomerList"
            : "getMemberList";
      },
      deep: true,
      immediate: true
    },
    searchFileValue(n) {
      this.searchValue = n;
    }
  },

  mounted() {
    if (this.$route.query.type === "fileSpace") {
      this.searchValue = this.searchFileValue;
    }
    this.remainDays = this.$utils.dateDiff();
    this.$bus.on("openCreateFolderDrawer", ({ id }) => {
      this.createFolderDrawerParams.drawerType = 2;
      this.createFolderDrawerParams.id = id;
      this.$refs.createFolderDrawer.drawerVisible = true;
    });

    // 上传资源
    this.$bus.on("uploadResources", () => {
      this.$refs.wanDrawer.drawerVisible = true;
    });
  },

  methods: {
    // 获取用户状态
    getUserType(value) {
      let data = "";
      switch (value) {
        case 0:
          data =
            this.remainDays <= 0 ? "体验用户（已过期请购买服务）" : "体验用户";
          break;
        case 1:
          data = "普通用户";
          break;
        case 2:
          data = this.remainDays <= 0 ? "企业VIP（已过期请续费）" : "企业VIP";
          break;
      }
      return data;
    },

    // 打开弹窗
    openDrawer(btnName) {
      // 过期的跳转付费界面  this.userInfo.userType === 0 体验用户 不允许添加成员
      if (
        this.remainDays <= 0 ||
        (["添加成员"].includes(btnName) && this.userInfo.userType === 0)
      ) {
        return this.$router.push({
          path: "/spacePay",
        });
      }
      switch (btnName) {
        case "上传资源":
          this.$refs.wanDrawer.drawerVisible = true;
          break;
        case "创建档夹":
          this.createFolderDrawerParams.drawerType = 1;
          this.$refs.createFolderDrawer.drawerVisible = true;
          break;
        case "添加客户":
          this.$bus.emit("openDrawer", "customerInfo");
          break;
        case "添加成员":
          this.$bus.emit("openDrawer", "teamManage");
          break;
        case "岗位设置":
          this.$bus.emit("openDrawer", "jobSetting");
          break;
        case "上传图片":
          this.$bus.emit("openDrawer", "spaceImages");
          break;
        case "添加分类":
          this.$bus.emit("openDrawer", "fileClass");
          break;
      }
    },

    // 提交 创建/修改档夹 的数据
    async onsubmit() {
      let dir = this.$refs["create-folder"];

      if (dir.classifyType) {
        dir.pickClassify();
      }

      // if (!dir.ruleForm.sysCateList && !dir.ruleForm.customContentCate)
      //   return this.$message.warning("请选择档务分类！");

      if (!dir.ruleForm.caseName)
        return this.$message.warning("请输入档夹名称！");

      if (
        dir.ruleForm.projectType === "d" &&
        (!dir.ruleForm.projectDate || !dir.ruleForm.projectDate.length)
      )
        return this.$message.warning("请选择项目周期！");

      if (!dir.resourceList.length)
        return this.$message.warning("请选择资源！");

      // 小程序分享图 coverUrl
      if (dir.ruleForm.coverUrlRaw) {
        dir.ruleForm.coverUrl = (
          await this.$utils.uploadFiles([{ raw: dir.ruleForm.coverUrlRaw }])
        ).url;
      }
      // 空间展示图 freeCoverUrl
      if (dir.ruleForm.freeCoverUrlRaw) {
        dir.ruleForm.freeCoverUrl = (
          await this.$utils.uploadFiles([{ raw: dir.ruleForm.freeCoverUrlRaw }])
        ).url;
      }

      // 项目周期
      dir.ruleForm.projectStartTime = dir.ruleForm.projectDate[0];
      dir.ruleForm.projectEndTime = dir.ruleForm.projectDate[1];
      // 成员
      dir.ruleForm.memberList = dir.memberList.map((item) => ({
        memberId: item.id,
      }));
      // 资源
      dir.ruleForm.resourceList = dir.resourceList.map((item) => ({
        resourceId: item.id,
      }));

      this.$store.commit("setLoading", true);
      let api =
        this.createFolderDrawerParams.drawerType === 1
          ? this.$http.createCase
          : this.$http.updateCase;
      api({
        ...dir.ruleForm,
        spaceId: this.userInfo.id,
      }).then(() => {
        this.$store.commit("setLoading", false);
        this.$message.success("提交成功");
        this.$refs.createFolderDrawer.drawerVisible = false;
        this.$bus.emit("getList");
        this.$store.commit("setLoading", false);
      });
    },

    loginout() {
      sessionStorage.clear();
      this.$store.dispatch("commitUserInfo", {});
      window.location.replace("https://www.wanspace.com.cn/");
    },

    getCustomList(v, type) {
      this.customType = v;
      this.$bus.emit("getCustomList", { v, type });
    },

    searchFile() {
      this.$store.commit("setSearchFileValue", this.searchValue);
      if (!this.$route.query.type) {
        sessionStorage.setItem("searchValue", this.searchValue);
        this.$router.push({
          path: "/productService",
          query: {
            type: "fileSpace"
          }
        });
        return;
      }
      this.$bus.emit("getList", 1);
    },

    spacePay(type) {
      switch (type) {
        case 1:
          // 续费
          this.$bus.emit("openSpacePay", "payService");
          break;
        case 2:
          // 订单记录
          this.$bus.emit("openSpacePay", "orderRecord");
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  height: 80px;
  margin: 20px 0 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    flex: 0 0 500px;

    span {
      font-size: 30px;
      color: #333;
      font-weight: bold;

      &.yellow-text {
        font-size: 20px;
        font-weight: normal;
        color: #ff6600;
      }

      &.init-text {
        font-size: 24px;
        font-weight: normal;
        color: #7a7b7c;
      }
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: end;
    align-items: center;

    .renewal-div {
      background: #e2e9ff;
      border-radius: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;
      box-sizing: border-box;
      margin-right: 33px;

      p {
        color: #7a7b7c;
        font-size: 18px;
      }
    }

    /deep/ .el-input {
      width: 400px;

      input {
        height: 50px;
        line-height: 50px;
        border-radius: 50px;
        font-size: 20px;
        text-indent: 27px;
        padding: 0;

        &::placeholder {
          color: #acadae;
        }
      }

      .el-input__suffix {
        margin-right: 16px;

        .el-icon-search {
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    /deep/ .el-button {
      width: 120px;
      height: 50px;
      line-height: 50px;
      background: #1b55f4;
      padding: 0;
      border-radius: 50px;
      color: #fff;
      border: none;
      font-size: 18px;
      margin: 0 0 0 20px;
    }

    .avator {
      width: 80px;
      height: 80px;
      background: skyblue;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 0 0 20px;
    }
  }
}
</style>
